import { computed, type Ref, unref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_CUSTOM_FIELDS } from '@/graphql/customFields';
import { CustomFieldEntity } from '@/types/composition-functions';
import type { CustomFieldDefinitionsQuery, CustomFieldDefinitionsQueryVariables } from '@/types/operations';

/**
 * School-defined custom field definitions for one record type (#574).
 * includeInactive is for the settings screen only (needs Custom Fields → View).
 */
export function useCustomFields(options: {
  entity?: CustomFieldEntity | Ref<CustomFieldEntity>;
  includeInactive?: boolean | Ref<boolean>;
  enabled?: Ref<boolean>;
} = {}) {
  const variables = computed<CustomFieldDefinitionsQueryVariables>(() => ({
    entity: unref(options.entity) ?? CustomFieldEntity.Student,
    include_inactive: unref(options.includeInactive) ?? false,
  }));

  const { result, loading, error, refetch } = useQuery<CustomFieldDefinitionsQuery, CustomFieldDefinitionsQueryVariables>(
    GET_CUSTOM_FIELDS,
    variables,
    () => ({ fetchPolicy: 'cache-and-network', enabled: options.enabled?.value ?? true }),
  );

  return {
    fields: computed(() => result.value?.customFields ?? []),
    loading,
    error,
    refetch,
  };
}
